import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { toDropDownOptions } from 'utils/dropdownOptions';
import telcoOptions from 'constants/options/telcoOptions';
import FilterField from '../FilterField';

const GroupTransactionsFilter = ({
  form,
  handleChange,
  typeName,
  types,
}) => (
  <>
    <FilterField
      name="purpose"
      label="Transaction Type"
      placeholder="Type"
      options={types}
      value={form.purpose}
      onChange={handleChange}
    />
    <FilterField
      name="provider_name"
      label="Transaction Provider"
      placeholder="Provider Name"
      options={toDropDownOptions(telcoOptions, true)}
      value={form.provider_name}
      onChange={handleChange}
    />
    <FilterField
      name="status"
      label="Transaction Status"
      placeholder="Status"
      options={toDropDownOptions(['success', 'pending', 'failed'])}
      value={form.status}
      onChange={handleChange}
    />
    <FilterField
      name="type"
      label={typeName}
      placeholder="Purpose"
      options={toDropDownOptions(['credit', 'debit'])}
      value={form.type}
      onChange={handleChange}
    />
    <FilterField
      name="category"
      label="Transaction Category"
      placeholder="Category"
      options={toDropDownOptions(['internal', 'external'])}
      value={form.category}
      onChange={handleChange}
    />
    <Form.Input
      fluid
      type="date"
      placeholder="Created at"
      label="Transaction Date"
      name="created_at"
      onChange={handleChange}
    />
  </>
);

GroupTransactionsFilter.propTypes = {
  form: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  typeName: PropTypes.string.isRequired,
  types: PropTypes.instanceOf(Array).isRequired,
};

export default GroupTransactionsFilter;
